"use client";

import * as Sentry from "@sentry/nextjs";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import type { ReactNode } from "react";
import { STRIPE_API_VERSION, STRIPE_OPTIONS } from "~/constants";
import { parseMutationErrorMessage } from "~/graphql-client";

export function StripeProvider(props: {
  children: ReactNode;
  stripePublishableKey: string;
}): React.ReactNode {
  // no await
  const stripePromise = loadStripe(props.stripePublishableKey, {
    apiVersion: STRIPE_API_VERSION,
  }).catch((error) => {
    const message = `Error loading payment config: ${parseMutationErrorMessage(
      error,
    )}`;
    console.error(message);
    Sentry.captureException(error);
    throw new Error(message);
  });

  return (
    <Elements stripe={stripePromise} options={STRIPE_OPTIONS}>
      {props.children}
    </Elements>
  );
}
